import { render, staticRenderFns } from "./playlist.vue?vue&type=template&id=56310570&"
import script from "./playlist.vue?vue&type=script&lang=js&"
export * from "./playlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports